(function () {
  var CACHE_PREFIX = 'wakeup-cart-reviews:v4:';
  var CACHE_TTL = 30 * 60 * 1000;
  var SELECTOR = '[data-wakeup-cart-reviews]';

  function parseNumber(value) {
    if (value === null || value === undefined) return 0;
    var normalized = String(value).replace(',', '.').trim();
    var number = parseFloat(normalized);
    return isNaN(number) ? 0 : number;
  }

  function normalizeRating10(value) {
    var num = parseNumber(value);
    if (num < 0) return 0;
    if (num > 10) return 10;
    return num;
  }

  function starWidthFrom10(value) {
    return Math.max(0, Math.min(100, normalizeRating10(value) * 10));
  }

  function isValidConfig(webshopId, publicCode) {
    if (!webshopId || !publicCode) return false;

    var id = String(webshopId).trim();
    var code = String(publicCode).trim();

    if (!id || id === '0') return false;
    if (!code || code === 'placeholder') return false;

    return true;
  }

  function buildApiUrl(webshopId, publicCode) {
    var params = new URLSearchParams({
      id: String(webshopId).trim(),
      public_code: String(publicCode).trim()
    });

    return 'https://dashboard.webwinkelkeur.nl/api/1.0/ratings_summary.json?' + params.toString();
  }

  function getCacheKey(webshopId, publicCode) {
    return CACHE_PREFIX + String(webshopId).trim() + ':' + String(publicCode).trim();
  }

  function clearLegacyCaches() {
    try {
      var keysToRemove = [];

      for (var i = 0; i < sessionStorage.length; i++) {
        var key = sessionStorage.key(i);
        if (!key) continue;

        if (
          key.indexOf('wakeup-cart-reviews:') === 0 &&
          key.indexOf(CACHE_PREFIX) !== 0
        ) {
          keysToRemove.push(key);
        }
      }

      keysToRemove.forEach(function (key) {
        sessionStorage.removeItem(key);
      });
    } catch (error) {}
  }

  function readCache(webshopId, publicCode) {
    try {
      var raw = sessionStorage.getItem(getCacheKey(webshopId, publicCode));
      if (!raw) return null;

      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.timestamp || !parsed.data) return null;

      if ((Date.now() - parsed.timestamp) > CACHE_TTL) {
        sessionStorage.removeItem(getCacheKey(webshopId, publicCode));
        return null;
      }

      return parsed.data;
    } catch (error) {
      return null;
    }
  }

  function writeCache(webshopId, publicCode, data) {
    try {
      sessionStorage.setItem(
        getCacheKey(webshopId, publicCode),
        JSON.stringify({
          timestamp: Date.now(),
          data: data
        })
      );
    } catch (error) {}
  }

  function normalizeSummary(payload) {
    if (!payload || typeof payload !== 'object') return null;

    if (String(payload.status || '').toLowerCase() === 'error') {
      return null;
    }

    var source = payload.data && typeof payload.data === 'object'
      ? payload.data
      : payload;

    var average10 = normalizeRating10(source.rating_average);
    var count = Math.max(0, Math.round(parseNumber(source.amount)));

    if (!average10 || !count) return null;

    return {
      average10: average10,
      count: count,
      starsWidth: starWidthFrom10(average10)
    };
  }

  function formatScore(score) {
    return normalizeRating10(score).toLocaleString('nl-NL', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    }) + '/10';
  }

  function hideNode(node) {
    if (!node) return;
    node.hidden = true;
    node.setAttribute('aria-hidden', 'true');
  }

  function showNode(node) {
    if (!node) return;
    node.hidden = false;
    node.removeAttribute('aria-hidden');
  }

  function renderNode(node, data) {
    if (!node || !data) return;

    var fill = node.querySelector('[data-cart-reviews-stars-fill]');
    var score = node.querySelector('[data-cart-reviews-score]');
    var count = node.querySelector('[data-cart-reviews-count]');
    var separator = node.querySelector('.wakeup-cart__reviews-separator');

    if (!fill || !score) {
      hideNode(node);
      return;
    }

    fill.style.width = data.starsWidth + '%';
    score.textContent = formatScore(data.average10);

    if (count) {
      var customText = (node.getAttribute('data-reviews-custom-text') || '').trim();
      var hideCount = node.getAttribute('data-hide-review-count') === 'true';

      if (hideCount) {
        count.textContent = '';
        count.hidden = true;
      } else if (customText) {
        count.textContent = customText;
        count.hidden = false;
      } else {
        count.textContent = '';
        count.hidden = true;
      }
    }

    if (separator) {
      if (count && !count.hidden && count.textContent.trim() !== '') {
        separator.hidden = false;
      } else {
        separator.hidden = true;
      }
    }

    showNode(node);
  }

  function fetchSummary(webshopId, publicCode) {
    var cached = readCache(webshopId, publicCode);
    if (cached) {
      return Promise.resolve(cached);
    }

    return fetch(buildApiUrl(webshopId, publicCode), {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      },
      credentials: 'omit',
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Reviews API request failed: ' + response.status);
        }
        return response.json();
      })
      .then(function (payload) {
        var normalized = normalizeSummary(payload);

        if (!normalized) {
          throw new Error('Reviews API payload invalid');
        }

        writeCache(webshopId, publicCode, normalized);
        return normalized;
      });
  }

  function mountNode(node) {
    if (!node || !node.isConnected) return Promise.resolve();

    var webshopId = node.getAttribute('data-webshop-id');
    var publicCode = node.getAttribute('data-public-code');

    if (!isValidConfig(webshopId, publicCode)) {
      hideNode(node);
      return Promise.resolve();
    }

    if (node.dataset.reviewsLoading === 'true') {
      return Promise.resolve();
    }

    node.dataset.reviewsLoading = 'true';

    return fetchSummary(webshopId, publicCode)
      .then(function (data) {
        if (!node.isConnected) return;
        renderNode(node, data);
      })
      .catch(function (error) {
        console.error('WakeUp cart reviews:', error);
        hideNode(node);
      })
      .finally(function () {
        if (node && node.isConnected) {
          node.dataset.reviewsLoading = 'false';
        }
      });
  }

  function mountAll() {
    var nodes = document.querySelectorAll(SELECTOR);
    if (!nodes.length) return Promise.resolve();

    var tasks = [];
    nodes.forEach(function (node) {
      tasks.push(mountNode(node));
    });

    return Promise.all(tasks);
  }

  function scheduleMount() {
    requestAnimationFrame(function () {
      mountAll();
    });
  }

  clearLegacyCaches();

  window.WakeupCartReviews = {
    mountAll: mountAll,
    scheduleMount: scheduleMount
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleMount);
  } else {
    scheduleMount();
  }

  document.addEventListener('cart:updated', scheduleMount);
  document.addEventListener('shopify:section:load', scheduleMount);
  window.addEventListener('pageshow', scheduleMount);
})();